export default __webpack_public_path__ + "static/media/pvilla4-1.b5cc2c98.webp";